import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { sendPageView } from "@/lib/beacon";

/**
 * Fires the first-party pageview beacon on every route change (this is a
 * client-routed SPA, so only the first load is a real navigation). Sits in
 * RootLayout next to ScrollToTop; renders nothing.
 */
const PageViewBeacon = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    sendPageView(pathname);
  }, [pathname]);

  return null;
};

export default PageViewBeacon;
